module.exports = __webpack_public_path__ + "static/img/caa-text.ac93c3bf.png";